import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

export default function Scanner({ onScan }) {
	const [deviceId, setDeviceId] = useState();
	const [devices, setDevices] = useState();
	const [stopStream, setStopStream] = useState(false);

	const handleDevices = React.useCallback(
		(mediaDevices) =>
			setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
		[setDevices]
	);

	const handleDeviceIdChange = (e) => {
		setDeviceId(e.target.value);
	};

	useEffect(() => {
		navigator.mediaDevices.enumerateDevices().then(handleDevices);
	}, [handleDevices]);

	const beep = (frequency, durationSec, ramp = false) => {
		var audioContext = null;
		var oscillatorNode = null;
		var stopTime = 0;
		if (oscillatorNode == null) {
			audioContext = new (window.AudioContext || window.webkitAudioContext)();
			stopTime = audioContext.currentTime;

			oscillatorNode = audioContext.createOscillator();
			oscillatorNode.type = "sine";
			oscillatorNode.connect(audioContext.destination);
			if (ramp) {
				oscillatorNode.frequency.setValueAtTime(frequency, stopTime);
			}
			oscillatorNode.start();
			oscillatorNode.onended = function () {
				oscillatorNode = null;
				audioContext = null;
			};
		}

		if (ramp) {
			oscillatorNode.frequency.linearRampToValueAtTime(frequency, stopTime); // value in hertz
		} else {
			oscillatorNode.frequency.setValueAtTime(frequency, stopTime); // value in hertz
		}

		stopTime += durationSec;
		oscillatorNode.stop(stopTime);
	};

	return (
		<>
			{!stopStream ? (
				<div className="columns">
					<div className="column has-text-centered">
						<BarcodeScannerComponent
							width={500}
							height={500}
							videoConstraints={deviceId ? { deviceId: deviceId } : null}
							onUpdate={(err, result) => {
								if (result) {
									beep(550, 0.2);
									//CODE_128 or QR
									if (result.format === 4 || result.format === 11) {
										onScan(result.text);
									} else {
										console.log(result);
									}
								}
							}}
							onError={(err) => {
								NotificationManager.error(
									err.toString(),
									"Error Starting Scan"
								);
							}}
							stopStream={stopStream}
						/>
					</div>
				</div>
			) : (
				<></>
			)}
			<div className="columns">
				<div className="column has-text-right">
					{devices ? (
						<select className="input" onChange={handleDeviceIdChange}>
							{devices.map((device, key) => (
								<option key={key} value={device.deviceId}>
									{device.label}
								</option>
							))}
						</select>
					) : (
						<></>
					)}
				</div>
				<div className="column">
					<button
						className="button is-primary"
						onClick={() => setStopStream(!stopStream)}
					>
						Toggle Scan
					</button>
				</div>
			</div>
		</>
	);
}
